import s from "./styles.module.scss";

const StickyModal = ({
  children,
  title,
  onClose,
  disableBackground,
  anchor,
  overlayProps,
  modalProps,
  modalStyles,
  separateTitle,
  position,
  rightSideStick,
  belowAnchor,
  inline,
  centered,
}) => {
  if (!anchor) return null;
  const boundary = anchor.getBoundingClientRect();

  return (
    <div onClick={onClose} className={disableBackground ? undefined : s.modalContainer} {...overlayProps}>
      <div
        className={s.modal}
        onClick={e => e.stopPropagation()}
        style={{
          position: "sticky",
          top: boundary.top,
          left: centered ? "calc(50% + var(--menu-width))" : boundary.left,
          ...(rightSideStick && {
            left: undefined,
            right: window.innerWidth - boundary.right,
            marginLeft: "auto",
          }),
          ...(belowAnchor && {
            top: boundary.top + boundary.height,
          }),
          ...(position && position(boundary)),
          ...(inline && { display: "inline-block" }),
          ...(centered && { transform: "translateX(calc(-50% - calc(var(--menu-width) / 2)))" }),
          ...modalStyles,
        }}
        {...modalProps}
      >
        <div>
          <div className={`${s.title}${separateTitle ? " border-bottom" : ""}`}>{title}</div>
          <div className={s.close} onClick={onClose}>
            &#10006;
          </div>
        </div>
        <div className={s.modalBody}>{children}</div>
      </div>
    </div>
  );
};

export default StickyModal;
